import React, { useContext, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import ResumeSubUseForm from "../../hooks/editor/resumeSubUseForm";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { logout } from "../../Store/Actions/authActions";

function SaveBEforeClose(props) {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleClosePopup=()=>{
    props.hidePopup()

    if(props&&props.leaveUrl=='/logout'){
      dispatch(logout())
    }else{
      history.push(props.leaveUrl)
    }
  }

  return (
    <>
      <Modal
        show={props.show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <button type="button" className="close" onClick={props.hidePopup}>
            <span aria-hidden="true">
              <img
                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                alt="closeicon"
                className="close_popup"
              />
            </span>
            <span className="sr-only">Close</span>
          </button>
          <div className="container">
            <div className="text-center">
              <h4 className="maintitle">Data not saved</h4>
              <p className="titledesc">
                Are you sure you want to leave without saving?
                <br />
                Once leave, this data cannot be Restored.
              </p>
            </div>
            <div className="row mt-4">
              <div className="col-md-6 col-sm-12 col-12">
                <button
                  className="btn primarybtn  float-right p-14 w-75"
                  style={{ lineHeight: "24px" }}
                  onClick={handleClosePopup}

                >
                  Leave
                </button>
              </div>

              <div className="col-md-6 col-sm-12 col-12">
                <button
                  className="btn primarybtn successbtn   w-75 mainborder"
                  onClick={() => {
                    props.resumeUpdateToServer();
                    handleClosePopup()
                  }}
                >
                    <span className="resume-options">Save and leave</span>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SaveBEforeClose;
